import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logUserAction } from '@office-start/telemetry-service';
export function logUpsellClick(id) {
    logUserAction({
        type: 'Click',
        id: id,
        area: 'FirstRun',
        result: 'Open',
        target: 'Other',
        eventName: KnownInstrumentationEvents.FirstRunUpsellClick,
    });
}
export function secondRunLogUpsellClick(id) {
    logUserAction({
        type: 'Click',
        id: id,
        area: 'SecondRun',
        result: 'Open',
        target: 'Other',
        eventName: KnownInstrumentationEvents.SecondRunUpsellClick,
    });
}
//# sourceMappingURL=logUpsellClick.js.map